import { Controller } from "@hotwired/stimulus"

// Navigates to the archived-filter URL when the checkbox is changed.
// Use for a standalone checkbox that toggles "include archived" without wrapping it in a link.
export default class extends Controller {
  static values = { url: String }

  navigate() {
    const url = this.urlValue
    if (url) {
      Turbo.visit(url, { action: "advance" })
    }
  }
}
